import { createAction } from "redux-api-middleware";
import AppSettings from "../config";
import networkSelectors from "../selectors/network";

export const GET_CRM_TOPICS_LOADING = "GET_CRM_TOPICS_LOADING";
export const GET_CRM_TOPICS_SUCCESS = "GET_CRM_TOPICS_SUCCESS";
export const GET_CRM_TOPICS_FAILURE = "GET_CRM_TOPICS_FAILURE";
export const GET_CRM_TOPICS_CLEAR = "GET_CRM_TOPICS_CLEAR";

export function getCrmTopics() {
  return createAction({
    endpoint: `${AppSettings.GOGOV_BASE_API_URL}/core/crm/topics`,
    method: "GET",
    headers: networkSelectors.defaultHeaders,
    types: [GET_CRM_TOPICS_LOADING, GET_CRM_TOPICS_SUCCESS, GET_CRM_TOPICS_FAILURE],
  });
}

export function getCrmTopicsClear() {
  return (dispatch: any) =>
    dispatch({
      type: GET_CRM_TOPICS_CLEAR,
    });
}
